import { render, staticRenderFns } from "./paymentcollectview.vue?vue&type=template&id=e1504588&scoped=true&"
import script from "./paymentcollectview.vue?vue&type=script&lang=js&"
export * from "./paymentcollectview.vue?vue&type=script&lang=js&"
import style0 from "./paymentcollectview.vue?vue&type=style&index=0&id=e1504588&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1504588",
  null
  
)

export default component.exports